import React from 'react';

import { QUESTION_TASK_TEXT } from '~/constants/read_const';

import { ReactComponent as IconRadioActive } from '~/assets/icons/active-radio-input.svg';
import { ReactComponent as IconRadioInactive } from '~/assets/icons/inactive-radio-input.svg';

import styles from './assets/styles/styles.module.scss';

class QuestionComponent extends React.Component {
  constructor(props) {
    super(props);
    this.mainRef = React.createRef();
  }

  async componentDidMount() {
    await this.mainRef.current.scrollIntoView();
    document.documentElement.scrollTop -= 180;
  }

  render() {
    const {
      questionsData,
      answerPickHandler,
      answersPicked,
      finishQuestionBlockHandler
    } = this.props;

    const {
      title,
      getResult
    } = QUESTION_TASK_TEXT;
    

    return (
      <div className={styles.question} ref={this.mainRef}>
        <div className={styles.wrapper}>
          <h2 className={styles['main-title']}>{title}</h2>
          <div className={styles.container}>
            {questionsData.map(({ question, rightAnswer, id, ...answers }, index) => {

              return (
                <div className={styles.block} key={index}>
                  <h3 className={styles.title}>{question}</h3>
                  <div className={styles['answers-block']}>
                    {Object.keys(answers).map((key, answerIndex) => (
                      <div className={styles.answer} key={answerIndex}>
                        <label className={styles['input-label']} onClick={() => answerPickHandler(index, key)}>
                          <div className={styles['input-icon-wrapper']}>
                            {answersPicked[index] === key ? (
                              <IconRadioActive className={styles['input-icon']} />
                            ) : (
                              <IconRadioInactive className={styles['input-icon']} />
                            )}
                          </div>
                          <input className={styles['radio-input']} type="radio" name={id}/>
                          <span className={styles['input-text']}>
                            {answers[key]}
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
          <button className={`${styles['get-result-button']} iq-tests-button`} type="button" onClick={finishQuestionBlockHandler}>
            {getResult}
          </button>
        </div>
      </div>
    );
  }
}

export default QuestionComponent;
